import { defineStore } from 'pinia';
import { ref, watch } from 'vue';

export const useDarkModeStore = defineStore('darkMode', () => {
  const isDarkMode = ref(false);

  // Load dark mode preference from localStorage
  const initDarkMode = () => {
    const saved = localStorage.getItem('darkMode');
    if (saved !== null) {
      isDarkMode.value = JSON.parse(saved);
    } else {
      // Check system preference
      isDarkMode.value = window.matchMedia('(prefers-color-scheme: dark)').matches;
    }
    applyDarkMode();
  };

  // Apply dark mode to document
  const applyDarkMode = () => {
    if (isDarkMode.value) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  };

  // Toggle dark mode
  const toggleDarkMode = () => {
    isDarkMode.value = !isDarkMode.value;
  };

  // Watch for changes and save to localStorage
  watch(isDarkMode, (newValue) => {
    localStorage.setItem('darkMode', JSON.stringify(newValue));
    applyDarkMode();
  });

  return {
    isDarkMode,
    initDarkMode,
    toggleDarkMode,
  };
});
